import './courses.css'
import Header from '../Header/Header'
import { Link } from 'react-router-dom'
import { useAuth } from '../../AuthContext/AuthContext'

const Courses = () => {
  const { user } = useAuth()

  return (
    <>
      <Header />
      <div className="courses-container-control">
        {user ? (
          <Link to="/premium" className="courses-choose">
            Платные
          </Link>
        ) : (
          <Link to="/auth" className="courses-choose">
            Платные
          </Link>
        )}
        <Link to="/courses/free" className="courses-choose">
          Бесплатные
        </Link>
      </div>
    </>
  )
}

export default Courses
